import { createFileRoute } from '@tanstack/react-router'
import { RelatorioDocumentosMes } from '@/features/relatorios-documentos-mes'
import { requireAdmin } from '@/lib/route-guards'

export const Route = createFileRoute(
  '/_authenticated/relatorios/documentos-mes/',
)({
  beforeLoad: async () => {
    await requireAdmin()
  },
  component: RelatorioDocumentosMes,
})
